import { FETCH_LANGUAGES_FAILURE } from 'constants/ActionTypes';
import { FETCH_TRANSLATIONS_FAILURE } from 'modules/i18n/actionTypes';

import { CURRENT_USER_DATA_FAILURE } from 'modules/users/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import { APPLICATION_LOADED_FAILED } from '../../actionTypes';

const ERROR_ACTIONS = [FETCH_TRANSLATIONS_FAILURE, FETCH_LANGUAGES_FAILURE, CURRENT_USER_DATA_FAILURE];

export default createReducer(null, {
  [APPLICATION_LOADED_FAILED]: () => true
}, [{
  matcher: ({ type }) => ERROR_ACTIONS.includes(type),
  reducer: (state, { error, payload }) => state || error || payload
}]);
